var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo2(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1300 100",
    width: 100,
    height: 50,
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    id: "Layer_1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#a1e2c1;}.cls-2{fill:#1c242a;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M187,46.29H0V1.08H187Z",
    className: "cls-1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M187,114.86H0V69.66H187Z",
    className: "cls-1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M187,183.44H0V138.23H187Z",
    className: "cls-1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M187,252H0V206.8H187Z",
    className: "cls-1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M227.72,252.35V0h90.15c41.64,0,74.22,11.59,97.39,35.12,23.54,23.17,35.12,53.58,35.12,91.6S438.8,195.14,415.63,218s-55.76,34.4-97.4,34.4ZM273,211.44h42c62.63,0,90.15-32.95,90.15-84.72,0-53.22-27.16-85.81-90.52-85.81H273Z",
    className: "cls-2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M484.05,252.35V0h98.12c22.81,0,42,7.6,57.93,23.17C656,38.38,664,57.2,664,80c0,32.95-18.46,60.1-46,71.69L679.2,252.35H628.15L574.2,162.56H529.31v89.79ZM529.31,122h48.15c24.62,0,41.64-17,41.64-41.27,0-23.17-16.3-39.83-38-39.83H529.31Z",
    className: "cls-2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M706.71,252.35V0H752V252.35Z",
    className: "cls-2"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M885.2,252.35,780.93,0h47.79L904,185.73,979.33,0h47.79L922.85,252.35Z",
    className: "cls-2"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M988.75,252.35,1094.11,0h38.37l105.36,252.35h-47.79L1169.41,202H1057.18l-20.64,50.33Zm82.55-87.62h84l-42-102.82Z",
    className: "cls-2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo2);
export default __webpack_public_path__ + "static/media/logo2.5bd2ec48a7739c2f3de83de62d040c58.svg";
export { ForwardRef as ReactComponent };